module.exports = __webpack_public_path__ + "img/procreate-desktop_en.e0aa08f.jpg";